<template>
    <div class="py-5 text-center">
        <div class="module-container container">
            <h1>{{pagedata.title.rendered}}</h1>
            <div v-if="!pagedata.acf.testi" v-html="formatLinks(pagedata.content.rendered)" class="content-container" v-on:mouseover="showPopup($event)" v-on:mousedown="showPopupOnClick($event)" v-on:mouseout="tooltip = ''"></div>
            <Quiz 
                v-if="pagedata.acf.testi"
                v-bind:quizdata="quizdata"
                v-bind:ingress="pagedata.content.rendered"
                v-bind:isCase="pagedata.acf.case_tehtava"
                v-bind:minScore="pagedata.acf.oikeat_vastaukset"
                v-on:completed="$emit('completed')"
                v-on:casecompleted="$emit('casecompleted')">
            </Quiz>
            <button class="button btn-red btn-start" v-show="isfirst" v-on:click="$emit('start')">{{ $t('general.aloita', currentLocale).toUpperCase() }}</button>
            <button class="button btn-red btn-start" v-show="islast" v-on:click="$emit('next')">{{ $t('general.seuraava', currentLocale).toUpperCase() }}</button>
            <div ref="tooltipContainer" class="tooltip-container" v-show="tooltip"></div>
        </div>
   </div>
</template>

<script>
    import keywordDictionary from '../../utils/dictionary'
    import Quiz from './Quiz.vue'

    export default {
        components: {
            Quiz
        },
        data: function () {
            return {
              quizdata: null,
              tooltip: '',
              tooltipContent: '',
            }
        },
        props: {
          pagedata: null,
          isfirst: false,
          islast: false
        },
        methods: {
          hasQuiz: function(){

          },
          showPopup: function(event){
            if( event.target.href && event.target.href.indexOf('word:') === 0 ){
              event.preventDefault()
              var keyword = decodeURI(event.target.href.split('word:')[1])
              this.tooltip = keyword;
              this.$refs.tooltipContainer.innerHTML = keywordDictionary.getWord(keyword)
              // this.$refs.tooltipContainer.style.left = (event.target.offsetLeft - 100) + 'px'
              this.$refs.tooltipContainer.style.top = event.target.offsetTop + 30 + 'px'
            }
          },
          showPopupOnClick: function(event){
            if( event.target.getAttribute('src') ){
                this.$emit('imageClick', event.target.getAttribute('src'))
            }
            this.showPopup(event) // redirect click to hover handler
          },
          formatLinks: function(html){
            return html.replace(new RegExp('href="word:', 'g'), 'class="tooltip-link" href="word:');
          }
        },
        computed: {
            currentLocale() {
                return this.$route.params.locale
            },
        },
        created: function() {
          if (this.pagedata.acf && this.pagedata.acf.tietovisa){
            this.quizdata = this.pagedata.acf.tietovisa
          }
        },
        mounted: function() {
          // console.log(this.$el.querySelector('a'));
        }
    }
</script>

<style>
    .btn-start{
        margin-top: 2em;
    }
    .module-container {
        max-width:1600px;
        position: relative;
        text-align: center;
        margin-bottom: 120px;
    }

    .module-container p{
        max-width: 720px;
        margin: 2em auto;
        text-align: left;
    }

    .module-container li {
        max-width: 720px;
        text-align: left;
        margin: 1em auto;
        list-style-type: none;
        position: relative;
        margin-bottom:1rem;
    }
    .module-container li:after {
        content: '\2022';
        position: absolute;
        left: -1.6em;
        font-size: 1.1em;
        top:0;
    }
    .module-container img{
        width:100%;
        max-width: 720px;
        height: auto;
        margin: 1em auto;
        cursor: pointer;
    }
    .module-container h1{
        text-align: center;
        margin-bottom: 2em;
    }

    figure.wp-block-table{ 
        position: relative;
        padding-bottom: 20px;
        padding-top: 25px;
        max-width: 720px;
        margin: 2em auto;
    }
    /* youtube embeds come wrapped to figure */
    figure{ 
        position: relative;
        padding-bottom: 56.25%;
        padding-top: 25px;
        max-width: 720px;
        margin: 2em auto;
    }
    figure iframe{
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }
    .wp-block-image,
    .wp-block-image figure{
        position: relative;
        padding: 0;
    }

    .wp-block-jco-postit{
        max-width: 720px;
        margin: 2em auto;
        background-color: #fff8e9;
        padding: 2em;
        /*  box-shadow: 0px 0px 6px 0px rgba(0,0,0,0.2); */
        background-image: url('../../assets/images/note-corner-beige.png');
        /* background-image: url('../../assets/images/note-corner-blue.png'); */
        background-repeat: no-repeat;
        background-position: bottom right;
    }

    .wp-block-jco-postit h2{
        color: #059DF3;
        font-size:  1.2em;
        font-style: italic;
    }

    .wp-block-jco-postit p{
        max-width: none;
    }

    .wp-block-table{
        max-width: 720px;
        margin: 2em auto;
    }
    .wp-block-table td{
        padding: 0.5em 1em;
        font-size: 0.9em;
        text-align: left;
        background-color: #eeeeee;
        border: solid 2px white;
        vertical-align: top;
    }
    @media(max-width: 480px) {
        .wp-block-table td{
            font-size: 0.8em;
            padding: 0.2em 0.4em;
        }
    }

    .tooltip-container{
        position: absolute;
        width: 320px;
        left: 0;
        right: 0;
        margin-left: auto;
        margin-right: auto;
        background: #EF5050;
        padding: 0;
        border-radius: 1em;
        line-height: 1.4em;
        z-index: 1300;
    }
    .tooltip-container p{
        color: white;
        margin: 1em;
    }
    .tooltip-link,
    .tooltip-link:hover{
        color: #EF5050;
        text-decoration: none;
        font-weight: 700;
    }
</style>


// WEBPACK FOOTER //
// src/views/components/Page.vue